"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsideContent = exports.ContentWrapper = exports.LoadingWrapper = exports.SectionTitle = exports.Wrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const wl_ui_kit_1 = require("@invent/wl-ui-kit");
const styled_1 = require("./card/styled");
exports.Wrapper = styled_components_1.default.div `
  height: 100%;
  padding: 0 ${(0, wl_ui_kit_1.getSizeBy)(4)};
`;
exports.SectionTitle = (0, styled_components_1.default)(wl_ui_kit_1.Body1) `
  height: 100%;
  margin: ${(0, wl_ui_kit_1.getSizeBy)(2.5)} 0;
  padding: ${(0, wl_ui_kit_1.getSizeBy)()} ${(0, wl_ui_kit_1.getSizeBy)(3)};
  background-color: ${(0, wl_ui_kit_1.getColor)('background')};
`;
exports.LoadingWrapper = styled_components_1.default.div `
  & > div {
    position: relative;
    width: 100%;
    height: 100%;
  }

  height: 100%;
`;
exports.ContentWrapper = styled_components_1.default.div `
  padding: ${(0, wl_ui_kit_1.getSizeBy)(1.5)} 0;

  ${styled_1.StyledCardWrapper}:has(+${exports.SectionTitle} ) {
    border: none;
  }
`;
exports.AsideContent = (0, styled_components_1.default)(wl_ui_kit_1.CardContent).attrs({ as: 'main' }) `
  flex-grow: 1;
  padding: 0;
  overflow-y: auto;
`;
